import type { Index } from '../services/api';

export type IndexSortField = 'name' | 'date';

function compareSharedDemoSortOrder(a: Index, b: Index): number {
  if (!a.is_default || !b.is_default) {
    return 0;
  }
  if (a.sort_order == null || b.sort_order == null) {
    return 0;
  }
  return a.sort_order - b.sort_order;
}

export function sortIndexes(
  indexes: Index[],
  sortBy: IndexSortField,
  sortAsc: boolean,
): Index[] {
  return [...indexes].sort((a, b) => {
    const sharedDemoOrder = compareSharedDemoSortOrder(a, b);
    if (sharedDemoOrder !== 0) {
      return sharedDemoOrder;
    }

    let comparison = 0;
    switch (sortBy) {
      case 'name':
        comparison = a.name.localeCompare(b.name);
        break;
      case 'date':
      default:
        comparison = new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
        break;
    }

    if (comparison !== 0) {
      return sortAsc ? comparison : -comparison;
    }

    const fallbackDemoOrder = compareSharedDemoSortOrder(a, b);
    if (fallbackDemoOrder !== 0) {
      return fallbackDemoOrder;
    }
    return a.index_id.localeCompare(b.index_id);
  });
}
